/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'
import { IdentificationIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor } from '@nexigendigital/nxui'
import { setCartItem } from 'store/slices/shopSlice'
import { CartItem } from 'models/shop'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    item: CartItem
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function NewDomainContact({ item }: Props) {
    const dispatch = useAppDispatch()

    return (
        <Option>
            <Label>
                <Icon>
                    <IdentificationIcon/>
                </Icon>
                <Anchor color={'primary'} onClick={() => dispatch(setCartItem({ template: 'contact', item }))}>
                    Add Domain Contact
                </Anchor>
            </Label>
        </Option>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const Option = styled.div`
    display: flex;
    padding: 8px 0;

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 16px;
    }
`

const Label = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

const Icon = styled.div`
    > svg {
        width: 16px;
        height: 16px;
        color: ${props => props.theme['icon--100']}
    }
`
